import React from "react";
import { useData } from "vike-react/useData";
import type { Data } from "./+data.js";

import { Stack, Space } from "@mantine/core";

import H1 from "#root/components/PageTitle";
import Description from "#root/components/PageDescription";
import PageBreadcrumbs from "#root/components/PageBreadcrumbs";
import TestimonialsBlockquote from "./components/TestimonialsBlockquote.jsx";

export default function Page() {
  const data = useData<Data>();
  const { pageTitle, pageDescription, crumbs } = data;

  return (
    <>
      <Stack bg="var(--mantine-color-body)" align="flex-start" justify="flex-start" gap="xs">
        <PageBreadcrumbs crumbs={crumbs} />
        <H1 title={pageTitle} />
        <Description text={pageDescription} />
      </Stack>
      <Space h="lg" />
      <TestimonialsBlockquote />
    </>
  );
}
